import { render, staticRenderFns } from "./history-tag.vue?vue&type=template&id=a354f292&"
import script from "./history-tag.vue?vue&type=script&lang=js&"
export * from "./history-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports